import React from 'react';
import { compose } from 'redux';

import FayeAuthentication, { extendFaye } from '../../faye_authentication';
import updateCompiledTheme from 'fantastic/actions/updateCompiledTheme';
import updateEntity from 'fantastic/actions/updateEntity';
import connectProps from 'shared/lib/connectProps';
import connectActions from 'shared/lib/connectActions';

class FayeClient extends React.Component {
  constructor(props) {
    super(props);
    const { settings: { faye: { url, user_id } } } = props;
    extendFaye();
    const client = new Faye.Client(url, { timeout: 120  });
    client.addExtension(new FayeAuthentication(client));
    client.subscribe(`/${user_id}`, this.messageHandler);
  }

  shouldComponentUpdate() {
    return false;
  }

  messageHandler = ({ type, data }) => {
    const { updateCompiledTheme, theme: { id } } = this.props;
    if(type === 'theme_update' && data.id === id) {
      updateCompiledTheme(data.asset_url);
    }
    if(type === 'entity_update') {
      const { updateEntity }= this.props;
      updateEntity(data);
    }
  }

  render() {
    return null;
  }
}

export default compose(
  connectProps('settings', 'theme'),
  connectActions({ updateCompiledTheme, updateEntity })
)(FayeClient);
